export default {"src":"/_next/static/media/earn-step-4.5759bba7.svg","height":629,"width":933,"blurWidth":0,"blurHeight":0};